/**
 * @format
 */

import request from '../../../helpers/request';
import { enqueueNotification } from '../../app';
import {
  REMOVE_LIST_VIEWER_OPTIMISTIC,
  REMOVE_LIST_VIEWER_SUCCESS,
  REMOVE_LIST_VIEWER_FAILURE,
} from '../actions';

export default (listId, viewerId, workspaceId) => {
  return async (dispatch, getState) => {
    // Get the full viewer object using the viewerId as key
    const state = getState();
    const viewer = state.deal.listMembers[viewerId];

    dispatch({
      type: REMOVE_LIST_VIEWER_OPTIMISTIC,
      payload: { viewerId, listId },
    });

    try {
      const { data } = await request.post(
        `/api/pipeline/lists/v1/${workspaceId}/${listId}/share/remove`,
        {
          members: [viewerId],
        },
        dispatch
      );

      if (data.success) {
        localStorage.setItem('listViewersLength', data.data.length);
        dispatch({
          type: REMOVE_LIST_VIEWER_SUCCESS,
        });
        return Promise.resolve(data);
      } else {
        const message = data.message;
        dispatch({
          type: REMOVE_LIST_VIEWER_FAILURE,
          payload: {
            message,
            viewer,
          },
        });
        dispatch(enqueueNotification(message));
        return Promise.reject(new Error(message));
      }
    } catch (err) {
      const message =
        'Something went wrong while removing list viewer, please try again.';
      dispatch({
        type: REMOVE_LIST_VIEWER_FAILURE,
        payload: {
          message,
          viewer,
        },
      });
      dispatch(enqueueNotification(message));
      return Promise.reject(err);
    }
  };
};
